<div class="container mt-3">
    <ng-content></ng-content>
</div>
